module.exports = __webpack_public_path__ + "img/bus-partner-img1.4a97f56a.png";